// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"0aa424be","214":"b9808253","230":"088f21c5","453":"500a67db","825":"0ceb7852","874":"c45cf5fd"}[chunkId] + ".chunk.js";
};